const ChangeCourseActionTypes = {
	FETCH_COURSES: {
		SUCCESS: 'FETCH_COURSES_SUCCESS',
		FAILURE: 'FETCH_COURSES_FAILURE',
		PENDING: 'FETCH_COURSES_PENDING',
	},

	CHANGE_ACTIVE_COURSE: {
		SUCCESS: 'CHANGE_ACTIVE_COURSE_SUCCESS',
		FAILURE: 'CHANGE_ACTIVE_COURSE_FAILURE',
		PENDING: 'CHANGE_ACTIVE_COURSE_PENDING',
	},
};

export default ChangeCourseActionTypes;
